var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"skeleton-description"},[_c('LineSkeleton',{attrs:{"width":"75%"}}),_c('LineSkeleton',{attrs:{"width":"85%"}}),_c('LineSkeleton',{attrs:{"width":"60%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }